import { initializePaddle, Paddle } from '@paddle/paddle-js';
import React, {
  useState,
  useEffect,
} from "react";

export default function Checkout() {
  // Create a local state to store Paddle instance
  const [paddle, setPaddle] = useState<Paddle>();

  // Download and initialize Paddle instance from CDN
  useEffect(() => {
    initializePaddle({ environment: 'sandbox', token: 'test_bfda518ec13124ce67f4cd776df' }).then(
      (paddleInstance: Paddle | undefined) => {
        if (paddleInstance) {
          setPaddle(paddleInstance);
        }
      },
    );
  }, []);

  // Callback to open a checkout
  const openCheckout = () => {
    paddle?.Checkout.open({
      items: [{ priceId: 'pri_01jwe0dnprcwemas2gha0xf0x9', quantity: 1 }],
    });
  };

  return (
    <button onClick={openCheckout}>
      Open Checkout
    </button>
  );
}